import { useEffect, useState } from 'react'
import { Select } from 'antd'
import { ChevronDownIcon } from 'components/Icons'

const OperatingStatusComboBox = ({
  allowClear = false,
  disabled = false,
  form = {},
  inputKey = 'facets_asset-status',
  options = [],
  placeholder = null,
  forceUpdate = () => {},
  onBlurTimeout = () => {},
  setFocus = () => {}
}) => {
  const FACETS_CONDITION_KEY = 'facets_condition'
  const CONDITION_RATING_TO_OPERATING_STATUS_MAPPER = {
    A: 'Operating',
    B: 'Operating',
    C: 'Requires Repair',
    CX: 'Requires Repair',
    D: 'Requires Repair',
    DX: 'Failed'
  }

  const conditionRating = form.getFieldValue(FACETS_CONDITION_KEY) || undefined
  const operatingStatus = form.getFieldValue(inputKey) || undefined

  const [selectedValue, setSelectedValue] = useState(operatingStatus)
  const [hasInitialised, setHasInitialised] = useState(false)

  useEffect(() => {
    setHasInitialised(true)
  }, [])

  useEffect(() => {
    if (!conditionRating || !hasInitialised) {
      return
    }

    const newOperatingStatus = CONDITION_RATING_TO_OPERATING_STATUS_MAPPER[conditionRating]

    form.setFieldsValue({ [inputKey]: newOperatingStatus})

    setSelectedValue(newOperatingStatus)

    forceUpdate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conditionRating])
  
  return (
    <Select
      suffixIcon={<ChevronDownIcon />}
      showSearch={options.length > 10 ? true : false}
      allowClear={allowClear}
      disabled={disabled}
      placeholder={placeholder}
      getPopupContainer={(trigger) => trigger.parentNode}
      filterOption={(inputValue, option) => {
        return (
          option.children
            ?.toLowerCase()
            .includes(inputValue.toLowerCase()) ||
          option.value.toLowerCase().includes(inputValue.toLowerCase())
        )
      }}
      value={selectedValue}
      onFocus={() => setFocus(true)}
      onBlur={() => onBlurTimeout()}
      onChange={(val) => {
        form.setFieldsValue({ [inputKey]: val})

        setSelectedValue(val)

        forceUpdate()
      }}
    >
      {options.map((option) => (
        <Select.Option key={option.code} value={option.code} />
      ))}
    </Select>
  )
}

export default OperatingStatusComboBox
